'use es6';

export const AI_EMAIL_ENRICHMENT = 'ai:email:parser:signature';
export const ATMENTION_USER_INVITE_MAP = 'Onboarding:atmention_user_invite_map';
export const COMPANY_CONTACT_ASSOCIATOR = 'companies:contact:associator';
export const DEAL_AMOUNT_CALCULATOR_PROPERTY = 'deals:deal_amount_calculation_property';
export const GDPR_COMPLIANCE_ENABLED = 'GDPRComplianceEnabled';
export const GDPR_COMPLIANCE_ENFORCED = 'GDPREnforcementEnabled';
export const LIFECYCLE_CONTACT_SYNC = 'deals::sync_company_lifecyclestage';
export const LINE_ITEM_COLUMNS = 'lineitems:columns';
export const PROPAGATE_OWNER = 'companies:propagate-owner';
export const RECORDING_SETTINGS_KEY = 'Integrations:Twilio:RecordingEnabled';
export const SFDC_V2_ENABLED = 'sfdc:v2-enabled';
export const VIEWED_MARKETING_EVENT_CONFIRM_MODAL = 'integrations:marketing-event:index-confirm';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}